import { gql, type TypedDocumentNode } from '@urql/core'
import type { LeadCreateInput } from './gql/graphql'

/** Mirrors backend `MakeContactMetaInput` (TypeGraphQL). */
export type MakeContactMetaInput = {
  inboxUrl?: string | null
  utmSource?: string | null
  utmMedium?: string | null
  utmCampaign?: string | null
  utmContent?: string | null
  utmTerm?: string | null
  brokerId?: string | null
  priceRange?: string | null
  purchaseTimeframe?: string | null
  mauticCookieHeader?: string | null
  hasWhatsApp?: boolean | null
}

export type MakeContactWithMetaVariables = {
  data: LeadCreateInput
  meta?: MakeContactMetaInput | null
}

export type MakeContactWithMetaResult = {
  makeContact: { id: string }
}

export const MakeContactWithMetaDocument: TypedDocumentNode<
  MakeContactWithMetaResult,
  MakeContactWithMetaVariables
> = gql`
  mutation MakeContact($data: LeadCreateInput!, $meta: MakeContactMetaInput) {
    makeContact(data: $data, meta: $meta) {
      id
    }
  }
`
